/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Not_Found_DescriptionInputs */

const nl_common_not_found_description = /** @type {(inputs: Common_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat je zoekt bestaat niet meer of is verwijderd.`)
};

/**

* @param {Common_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_not_found_description = /** @type {((inputs?: Common_Not_Found_DescriptionInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Not_Found_DescriptionInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_not_found_description(inputs)
});
export { common_not_found_description as "common.not_found_description" }